<template>
  <span class="login-status">
    <div  class="user-box" v-if="currentUser">
      <table class="user-box-table">
        <tr>
          <td>
            <img  class="mini-user-profile-image" :src="currentUser.profile_image_url"/>
          </td>
          <td>
            <div class="user-name">{{currentUser.display_name}} </div>
            <div v-if="currentBalance">{{formatCurrency(currentBalance.total)}} <img style="width: 13px;" :src="currencyIcon('sb')" alt="SwiftBUCKS" /></div>
            <div v-if="currentGoldBalance">{{formatCurrency(currentGoldBalance.total)}} <img style="width: 13px;" :src="currencyIcon('mt')" alt="SwiftGOLD" /></div>
            <div v-if="!noDiscord">
              <svg style="" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-discord" viewBox="0 0 16 16">
                <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"></path>
              </svg>
            </div>
          </td>
        </tr>
      </table>
      <div v-if="noDiscord" style="padding:10px;">
          <discord-btn v-if="noDiscord" style="font-size : 18px;padding: 0px 5px 0px 5px;width:145px;">Add Discord</discord-btn>
      </div>
      <div v-else>
        
      </div>
    </div>
    <span v-else>
      <login-btn style="font-size : 18px;padding-right: 5px;width:110px;">Login&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</login-btn>
    </span>
  </span>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'

export default {
  name: 'debug',
  async created () {
  },
  data () {
    return {
    }
  },
  computed: Object.assign(mapState([
    'currentUser', 'currentBalance', 'currentGoldBalance'
  ]), {
    noDiscord () {
      return this.currentUser && !this.currentUser.has_discord
    }
  }),
  methods: {
    currencyIcon (priceCurrencyType) {
      let image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png'

      return `${Vue.config.WEB_ASSET_BASE_URL}/${image}`
    }
  }
}
</script>

<style scoped>
.user-box{
  background-color: #00000028;
  border-radius: 0px 0px 0px 20px;
  border-left: 3px rgba(255, 255, 255, 0.2) solid;
  cursor: default;
}
td{
  padding: 5px;
  text-align: left;
}

.user-name{
  font-size: 20px;
}
.login-status {
  position: absolute;
  right: 10px;
}
.mini-user-profile-image {
  width:50px;
  min-height: 50px;
  border-radius: 50%;
  border: 2px white solid;
}

.mini-user-name {
  margin-left: 35px;
}
</style>


// WEBPACK FOOTER //
// src/components/Login-Status.vue